/*
 * aoe-analytics.js
 * Pushes storefront interaction events into the GTM dataLayer.
 *
 * Two mechanisms:
 *  1. add_to_cart  - hooks the theme's existing pub/sub cart events
 *                    (subscribe / PUB_SUB_EVENTS from pubsub.js + constants.js).
 *  2. Declarative button tracking - any element with a data-gtm-event attribute
 *     pushes that event name on click. Extra data-gtm-* attributes ride along,
 *     e.g.  <a data-gtm-event="cta_click" data-gtm-label="hero_shop_now">
 *     pushes { event:'cta_click', label:'hero_shop_now' }.
 *
 * Loaded as a deferred classic script AFTER constants.js + pubsub.js so the
 * globals `subscribe` and `PUB_SUB_EVENTS` are already defined.
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  function dl(obj) {
    window.dataLayer.push(obj);
  }

  function currency() {
    try {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || undefined;
    } catch (e) {
      return undefined;
    }
  }

  // --- 1. add_to_cart via the theme's pub/sub --------------------------------
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      try {
        if (!event) return;
        // Only product-form / quick-add represent a genuine "add". Cart-page
        // quantity edits also publish cartUpdate but we ignore those here.
        if (event.source !== 'product-form' && event.source !== 'quick-add') return;

        var data = event.cartData || {};
        var item = null;
        if (data.id && data.product_title) {
          item = data; // /cart/add.js returns the added line item directly
        } else if (Array.isArray(data.items) && data.items.length) {
          item = data.items[data.items.length - 1];
        }
        if (!item) return;

        dl({ ecommerce: null });
        dl({
          event: 'add_to_cart',
          ecommerce: {
            currency: currency(),
            value: (item.final_line_price || item.line_price || item.final_price || item.price || 0) / 100,
            items: [{
              item_id: item.sku || String(item.product_id || item.id || ''),
              item_name: item.product_title || item.title,
              item_variant: item.variant_title || undefined,
              price: (item.final_price || item.price || 0) / 100,
              quantity: item.quantity || 1
            }]
          }
        });
      } catch (e) {
        /* never let analytics break the cart */
      }
    });
  }

  // --- 2. Declarative button / link tracking ---------------------------------
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-gtm-event]') : null;
    if (!el) return;

    var payload = { event: el.getAttribute('data-gtm-event') };
    for (var i = 0; i < el.attributes.length; i++) {
      var attr = el.attributes[i];
      if (attr.name.indexOf('data-gtm-') === 0 && attr.name !== 'data-gtm-event') {
        var key = attr.name.replace('data-gtm-', '').replace(/-/g, '_');
        payload[key] = attr.value;
      }
    }
    dl(payload);
  }, true);
})();
